import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledTooltip,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { payApprove } from "../../slices/apps/packageSlice";

// data dosyaları
import Question from "../../assets/images/question.png";

const BulkSalePayApproveModal = ({ id }) => {
  const dispatch = useDispatch();

  // states
  const [modal, setModal] = useState(false);

  // states
  const { payApproveLoading } = useSelector((state) => {
    return {
      payApproveLoading: state.package.payApproveLoading,
    };
  }, shallowEqual);

  const setPayApprove = async () => {
    const data = {
      packageAgencyId: id,
      isPaid: true,
    };

    try {
      const resultAction = await dispatch(payApprove(data));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  function tog_large(e) {
    if (e) {
      setModal(true);
    } else setModal(false);
  }

  return (
    <Fragment>
      <span
        id={`bulk-sale-pay-approve-tooltipTop-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={() => tog_large(true)}
      >
        <i
          className="bx bx-money text-dark"
          style={{
            fontSize: "20px",
          }}
        />
      </span>

      <UncontrolledTooltip
        placement="top"
        target={`bulk-sale-pay-approve-tooltipTop-${id}`}
      >
        Ödeme Onayla
      </UncontrolledTooltip>

      <Modal
        size="md"
        isOpen={modal}
        toggle={() => {
          tog_large(false);
        }}
      >
        <ModalHeader
          className="modal-title "
          id="myLargeModalLabel"
          toggle={() => {
            tog_large(false);
          }}
        >
          Ödeme Onayla
        </ModalHeader>

        <ModalBody className="text-center text-dark">
          <img
            src={Question}
            alt="SMS Question"
            id="candidate-img"
            className="img-fluid mb-4"
            style={{ height: "80px" }}
          />
          <h4 className="text-dark">
            Bu satışı ödendi olarak işaretlemek istediğinize emin misiniz?
          </h4>
          <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
            <Button
              className="btn btn-sm"
              color="primary"
              disabled={payApproveLoading}
              onClick={setPayApprove}
            >
              Onayla
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default BulkSalePayApproveModal;
